var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { fetchAffiliatons } from '../../requests';
import { useGlobalDispatch, useProfileState } from '../../hooks';
import { useState, useEffect } from 'react';
import { handleIconSSOLogins } from '../NetworkSearch/AppCard';
export function AppContainerIcon(_a) {
    var _this = this;
    var app = _a.app;
    // const { relianceAccounts } = useProfileState()
    var label = app.label, icon = app.icon, name = app.name, link = app.link;
    var dispatch = useGlobalDispatch();
    var profile = useProfileState();
    var _b = useState(null), affiliations = _b[0], setAffiliations = _b[1];
    var email = profile.email, staffId = profile.staffId;
    useEffect(function () {
        fetchAffiliatons(profile)
            .then(function (affiliations) { return setAffiliations(affiliations); })
            .catch(function (error) { return console.log(error); });
    }, [profile]);
    var handleIconClick = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: 'set global loading', payload: true });
                    return [4 /*yield*/, handleIconSSOLogins({
                            appName: name,
                            affiliations: affiliations,
                            link: link,
                            email: email,
                            staffId: staffId,
                        })];
                case 1:
                    _a.sent();
                    dispatch({ type: 'set global loading', payload: false });
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx("li", __assign({ style: { position: 'relative' }, onClick: handleIconClick }, { children: _jsxs(Container, { children: [_jsx("img", { src: icon, alt: label }, void 0),
                _jsx("p", __assign({ className: 'header-app-text' }, { children: label.length < 10 ? label : label.substr(0, 8) + '...' }), void 0),
                _jsx("p", __assign({ className: 'header-app-text-hover' }, { children: label }), void 0)] }, void 0) }), void 0));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: border-box;\n  width: 80px;\n  height: 80px;\n  padding-top: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  &:hover {\n    border-radius: 4px;\n    background-color: rgba(218, 220, 224, 0.25);\n    & .header-app-text {\n      display: none;\n    }\n    & .header-app-text-hover {\n      display: block;\n    }\n  }\n  img {\n    width: 40px;\n    height: 40px;\n  }\n  .header-app-text-hover {\n    display: none;\n  }\n  p {\n    font-family: HelveticaNeue;\n    font-size: 12px;\n    text-align: center;\n    margin-top: 0;\n    margin-bottom: 4px;\n    color: #1f2123;\n    /* white-space: nowrap; */\n  }\n"], ["\n  box-sizing: border-box;\n  width: 80px;\n  height: 80px;\n  padding-top: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  &:hover {\n    border-radius: 4px;\n    background-color: rgba(218, 220, 224, 0.25);\n    & .header-app-text {\n      display: none;\n    }\n    & .header-app-text-hover {\n      display: block;\n    }\n  }\n  img {\n    width: 40px;\n    height: 40px;\n  }\n  .header-app-text-hover {\n    display: none;\n  }\n  p {\n    font-family: HelveticaNeue;\n    font-size: 12px;\n    text-align: center;\n    margin-top: 0;\n    margin-bottom: 4px;\n    color: #1f2123;\n    /* white-space: nowrap; */\n  }\n"])));
var templateObject_1;
